export const CUMULATIVE_LOANS_KEY = 'CUMULATIVE_LOANS_KEY';
export const TOTAL_LOANS_KEY = 'TOTAL_LOANS_KEY';
export const TOTAL_LOANS_SHARED_KEY = 'TOTAL_LOANS_SHARED_KEY';
export const CUMULATIVE_USERS_KEY = 'CUMULATIVE_USERS_KEY';
export const VISITS_KEY = 'VISITS_KEY';

export type CumulativeLoansResponse = {
    fileContent: string;
    totalLoans: number;
};

export type TotalLoansResponse = {
    averageLoansDuringCampaign: number;
    averageLoansPlus: number;
    fileContent: string;
};

export type TotalLoansSharedResponse = {
    averageLoansDuringCampaign: number;
    averageLoansPlus: number;
    fileContent: string;
};

export type CumulativeUsersResponse = {
    fileContent: string;
    registeredUsersPlus: number;
    totalRegisteredUsers: number;
};

export type VisitSource = {
    host: string;
    path: string;
    uri: string;
    views: {
        number: number;
        percentage: number;
    };
};

export type VisitsResponse = {
    sources: VisitSource[];
    total: number;
};

export type CampaignResult = {
    [CUMULATIVE_LOANS_KEY]: CumulativeLoansResponse;
    [TOTAL_LOANS_KEY]: TotalLoansResponse;
    [TOTAL_LOANS_SHARED_KEY]?: TotalLoansSharedResponse;
    [CUMULATIVE_USERS_KEY]: CumulativeUsersResponse;
    [VISITS_KEY]: VisitsResponse;
};
